import { render, staticRenderFns } from "./referralChain.vue?vue&type=template&id=a6b78ac2&scoped=true"
import script from "./referralChain.vue?vue&type=script&lang=js"
export * from "./referralChain.vue?vue&type=script&lang=js"
import style0 from "./referralChain.vue?vue&type=style&index=0&id=a6b78ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b78ac2",
  null
  
)

export default component.exports